export default __webpack_public_path__ + "static/media/walnut.ab6b6c7a.webp";